/* global window */

import React from 'react';
import { Helmet } from 'react-helmet';

// favicons
import faviconIco from './assets/favicon.ico';
import faviconDark from './assets/localmed-dark.png';

export default function DIFavicon() {
  let isDarkMode;
  if (typeof window !== 'undefined') {
    isDarkMode = window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  }
  return (
    <Helmet>
      {isDarkMode ? (
        <link id="favicon-dark" rel="icon" type="image/png" href={faviconDark} />
      ) : (
        <link id="favicon" rel="icon" type="image/x-icon" href={faviconIco} />
      )}
    </Helmet>
  );
}
